import React, { useState } from "react";
import { SlideDown } from "react-slidedown";
import "react-slidedown/lib/slidedown.css";
import Invitations from "./Invitations";
import CreatePost from "../Home/CreatePost";
import Grid from "@mui/material/Grid";

const InvitationForm = ({ invitations, requests }) => {
  const [closeForm, setCloseForm] = useState(true);
  const [post, setPost] = useState({});

  return (
    <>
      <SlideDown closed={closeForm}>
        <div className="userForm">
          <span
            className="closeFormBtn"
            onClick={(e) => {
              e.preventDefault();
              setCloseForm(!closeForm);
            }}
          >
            X
          </span>

          <div className="form">
            <CreatePost
              post={post}
              setPost={setPost}
              setCloseForm={setCloseForm}
              closeForm={closeForm}
            />
          </div>
        </div>
      </SlideDown>

      {closeForm && (
        <div className="homeGrid">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Invitations
                data={invitations}
                closeForm={closeForm}
                setCloseForm={setCloseForm}
                setPost={setPost}
                post={post}
              />
            </Grid>
            <Grid item xs={6}>
              <Invitations
                data={requests}
                closeForm={closeForm}
                setCloseForm={setCloseForm}
                setPost={setPost}
                post={post}
              />
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );
};

export default InvitationForm;
